/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * The new role for the nursery member
 */
export enum UpdateMemberRoleDtoRole {
  MANAGER = "MANAGER",
  DEPUTY_MANAGER = "DEPUTY_MANAGER",
  LEADER = "LEADER",
  PRACTITIONER = "PRACTITIONER",
}
